import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiBilling } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const getAccountPaymentInfo = () => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        uid:  userData.smsAuth.userId,
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    try {
        const { data: { status, data } } = await apiBilling.post('/services/getAccountPaymentInfo', params, config)
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setAccountPaymentInfo,
                value: {
                    paymentInfo: data
                },
            })
        }
        dispatch({
            type: storeDispatchTypes.setPaymentInfoLoaded,
            value: {
                paymentInfoLoaded: true
            },
        })
    } catch (e) {
        console.error('get account payment info failed', e)
        dispatch({
            type: storeDispatchTypes.setPaymentInfoLoaded,
            value: {
                paymentInfoLoaded: true
            },
        })
    }

}

export default getAccountPaymentInfo
